import { useEffect, useState } from "react";
import servicosColaborador from "../../servicos/servicos-colaborador";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { DataGrid } from "@mui/x-data-grid";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import Box from "@mui/material/Box";
import Spinner from "../components/Spinner";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import ExcelJS from 'exceljs';

const ListPontuacoes = () => {
    const [pontuacoes, setPontuacoes] = useState([]);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        servicosColaborador.listarPontuacoes().then(response => {
            if (response.status === 200) {
                setPontuacoes(response.data)
            }
        }).catch(error => console.log(error))
    }, [])

    const handlePesquisa = (e) => {
        const pesquisa = e.target.value;
        let listaAtualizada = [];
        if (pesquisa !== "") {
            listaAtualizada = pontuacoes.filter((item) => {
                return String(item.nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
            })
            setListaFiltrada(listaAtualizada);
        } else {
            setListaFiltrada(pontuacoes);
        }
    }

    const columnsPontuacoes = [
        { field: "id_colaborador", headerName: "ID", width: 90 },
        {
            field: "nome",
            headerName: "Nome",
            width: 250,
            editable: false,
        },
        {
            field: "ponto",
            headerName: "Milhas Vigentes",
            width: 150,
            editable: false,
        },
    ];


    const onRowsSelectionHandler = (ids) => {
        const selectedRowsData = ids.map((item) => pontuacoes.find((row) => row.id_colaborador === item.id_colaborador));
        setSelectedRows(selectedRowsData);
    };

    const actions = [
        { icon: <ShareIcon />, name: 'Exportar Excel' },
    ];

    const handleActionClick = (actionName) => {
        switch (actionName) {
            case 'Exportar Excel':
                handleExportToExcel();
                break;
            default:
                break;
        }
    };

    const handleExportToExcel = () => {
        const selectedRowsIds = selectedRows.map((rowIndex) => rowIndex.id_colaborador);
        const selectedPontuacoes = pontuacoes.filter((pontuacao) => selectedRowsIds.includes(pontuacao.id_colaborador));

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Pontuações');

        columnsPontuacoes.forEach((column, index) => {
            worksheet.getColumn(index + 1).header = column.headerName;
            worksheet.getColumn(index + 1).key = column.field;
            worksheet.getColumn(index + 1).width = 10;
        });

        selectedPontuacoes.forEach((pontuacao) => {
            const rowData = {};
            columnsPontuacoes.forEach((column) => {
                if (column.field === 'id_colaborador') {
                    rowData[column.field] = pontuacao.id_colaborador;
                } else if (column.field === 'nome') {
                    rowData[column.field] = pontuacao.nome
                } else if (column.field === 'ponto') {
                    rowData[column.field] = pontuacao.ponto
                }
            });
            worksheet.addRow(rowData);
        });

        const saveOptions = {
            filename: 'saldo_milhas_colaboradores.xlsx',
            useStyles: true,
            useSharedStrings: true
        };

        workbook.xlsx.writeBuffer().then((buffer) => {
            const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.download = saveOptions.filename;
            link.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 100);
        });
    };

    const SpeedDialShared = () => {
        return (
            <Box sx={{ height: 100, transform: 'translateZ(0px)', flexGrow: 1 }}>
                <SpeedDial
                    ariaLabel="SpeedDial"
                    sx={{ position: 'absolute', bottom: 38, right: 16, }}
                    icon={<SpeedDialIcon />}
                    FabProps={{
                        sx: {
                            bgcolor: '#753BBD',
                            '&:hover': {
                                bgcolor: '#753BBD',
                            }
                        }
                    }}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            key={action.name}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            onClick={() => handleActionClick(action.name)}
                        />
                    ))}
                </SpeedDial>
            </Box>
        )
    }

    return <>
        <NavMenu />
        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>
            {pontuacoes.length === 0 ?
                <div className="w-75 d-flex justify-content-center align-items-center"><Spinner mensagem="Carregando lista de pontuações..." /> </div> :
                <div className="w-75 tabelas-gerenciais">
                    <Box sx={{ height: 650, width: 950, marginTop: 1 }}>
                        <input
                            className="p-1 mb-2 border-1 rounded-5"
                            type="text"
                            id="pesquisa"
                            placeholder="Pesquise pelo nome"
                            onChange={handlePesquisa}
                        />

                        <DataGrid
                            localeText={localizedTextsMap}
                            rows={listaFiltrada.length > 0 ? listaFiltrada : pontuacoes}
                            columns={columnsPontuacoes}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                            }
                            getRowId={(row) => row.id_colaborador}
                            checkboxSelection
                            onSelectionModelChange={(ids) => {
                                const selectedIDs = new Set(ids);
                                const selectedRowData = pontuacoes.filter((row) =>
                                    selectedIDs.has(row.id_colaborador)
                                )
                                onRowsSelectionHandler(selectedRowData);
                            }}
                        />
                    </Box>
                    <Box mt={5}>
                        <SpeedDialShared />
                    </Box>
                </div>
            }

        </div>
    </>
}

export default ListPontuacoes;